export default __webpack_public_path__ + "static/media/china.265c48.svg";